<template>
  <div class="product-credit">
    <div>
      <DefImg
        :result="{
          src: `/local/templates/sova/images/credits/${result.CODE}.png`,
          alt: result.CODE,
          width: '64',
          height: '64',
        }"
      />
    </div>
    <div class="product-credit-description">
      <div class="product-credit-controls">
        <h3 class="product-credit-title">
          {{ result.PRINT_NAME }}
        </h3>
        <p class="product-credit-text">
          {{ minPrice?.printPsMonthlyPriceText }}
        </p>
        <p class="product-credit-text">
          {{ result?.payData?.payments }}
        </p>

        <DefSelectWrapper v-if="result.payData">
          <template #header>
            {{ result.payData.PARTS_COUNT }}
          </template>
          <template v-if="messages" #placeholder>
            {{ messages.term }}
          </template>
          <div v-for="month in getMonthsArray" @click="changeMonth(month)">
            {{ month }}
          </div>
        </DefSelectWrapper>
      </div>
      <div class="product-credit-buy">
        <p v-if="price?.printPsMonthlyPrice" class="product-credit-month">
          {{ price.printPsMonthlyPrice }} / {{ messages?.monthlyPay }}
        </p>
        <div v-if="price?.printPsFirstMonthPrice" class="product-credit-first">
          <p class="product-credit-first__name">
            <!--                Первый платеж:-->
            {{ messages?.firstPay }}:
          </p>
          <p>{{ price.printPsFirstMonthPrice }}</p>
        </div>
        <DefButtonSecondary :small="true" @click="handlerBuy">{{
          basketMessages.buy
        }}</DefButtonSecondary>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps, computed } from 'vue';
import { useStore } from '@/store';
import Analytics from '@/utils/Analytics';
import DefImg from '@components/Def/DefImg/DefImg.vue';
import DefButtonSecondary from '@components/Def/DefButtonSecondary/DefButtonSecondary.vue';
import DefProgramMe from '@components/Def/DefProgramMe/DefProgramMe.vue';
import DefSelectWrapper from '@components/Def/DefSelect/DefSelectWrapper.vue';

const props = defineProps(['result']);

const { state, dispatch } = useStore();
const basketMessages = computed(() => state.basket.data.messages);
const product = computed(() => state.product.data.product);
const messages = computed(() => state.product.data.messages);
const price = computed(() => props.result?.payData?.price);
const minPrice = computed(() => props.result?.payData?.minPrice);
const quantity = computed(() => state.product?.data?.product?.price?.quantity);

const banksStartMonth = {
  PRIVATBANK: 2,
  PRIVATBANK_PP: 3,
  MONOBANK: 3,
};

const getMonthsArray = computed(() => {
  const arr = [];
  for (
    let i = banksStartMonth[props.result.CODE];
    i <= +props.result.payData.MAX_PARTS_COUNT;
    i++
  ) {
    arr.push(i);
  }
  return arr;
});
const { psInputCode } = props.result;
const otherPaySystemsRequestData = computed(() => {
  const paySystems = state.product.data.product.paySystem.items.filter(
    (el) => el.psInputCode !== psInputCode
  );
  const requestData = {};
  paySystems.map((el) => {
    requestData[el.psInputCode] = el.payData.PARTS_COUNT;
  });
  return requestData;
});
const setPartsCount = (PARTS_COUNT) => {
  // 'ORDER_PROP_29' - property PrivatBank in Bitrix, where you can find settings of the prop and choose correct ORDER_PROP_ID
  // https://sova2-3.bi3x.org/bitrix/admin/sale_order_props_edit.php?lang=ru&ID=29&filter=Y&set_filter=Y
  dispatch('product/updatePageData', {
    ...otherPaySystemsRequestData.value,
    [psInputCode]: PARTS_COUNT,
    quantity: quantity.value,
    OFFER_ID: product?.value?.offer?.id ?? product?.value?.id,
  });
  // commit('checkout/setRequestData', { name : result.psOrderProp, value: JSON.stringify( partsCount ) });
};
const changeMonth = (month) => {
  setPartsCount(month);
  // dispatch('checkout/setAjax');
};

const handlerBuy = async () => {
  try {
    Analytics.addToBasket(product.value);
    const params = {
      action: 'createCreditOrder',
      productId: product.value?.offer?.id || product.value?.id,
      quantity: product.value?.price?.quantity || 1,
    };
    const checkoutData = {
      CODE: props.result.CODE,
      PARTS_COUNT: props.result.payData.PARTS_COUNT,
    };

    sessionStorage.setItem('createCreditOrder', JSON.stringify(checkoutData));

    const { status, data } = await axios.post('/ajax/', params);

    if (data?.pathToCheckout) {
      location.href = data.pathToCheckout;
    }
  } catch (err) {
    console.error(err);
  }
};
</script>

<script>
export default {
  name: 'ProductCredit',
};
</script>

<style lang="scss" scoped>
.product-credit {
  display: grid;
  grid-template-columns: 32px minmax(0, 1fr);
  grid-column-gap: 16px;
  padding: 16px 0;
  &:not(:last-child) {
    border-bottom: 1px solid #cacece;
  }
  @include point-md {
    grid-template-columns: 44px minmax(0, 1fr);
    padding: 24px 0;
  }
  :deep(.product-installments) {
    margin-bottom: 24px;
  }
  :deep(.def-content) {
    font-size: rem(16);
    margin-top: 10px;
  }
}
.product-credit-title {
  font-size: 16px;
  font-weight: 600;
  line-height: 125%;
  margin-bottom: 8px;
  @include point-md {
    font-size: 18px;
  }
}
.product-credit-month {
  font-size: 16px;
  font-weight: 600;
  line-height: 125%;
  margin-bottom: 8px;
  @include point-md {
    font-size: 18px;
  }
}
.product-credit-description {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  grid-row-gap: 16px;
  @include point-md {
    grid-template-columns: minmax(0, 1.5fr) minmax(0, 1fr);
    grid-column-gap: 24px;
  }
  @include point-lg {
    grid-template-columns: minmax(0, 2fr) minmax(0, 220px);
  }
}
.product-credit-controls {
  display: flex;
  flex-direction: column;

  @include point-md {
    align-items: flex-start;
  }
  :deep(.def-select-wrapper) {
    margin-top: 12px;
    @include point-md {
      margin-top: 8px;
      max-width: 190px;
    }
  }
}
.product-credit-first {
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 500;
  line-height: 125%;
  margin-bottom: 16px;
  @include point-md {
    font-size: 16px;
  }
  &__name {
    color: #5f5f67;
    margin-right: 8px;
  }
}
.product-credit-buy {
  display: flex;
  flex-direction: column;
  @include point-md {
    align-items: flex-end;
  }
  :deep(.def-button-secondary) {
    width: 100%;
  }
}
.product-credit-text {
  font-size: 14px;
  font-weight: 500;
  line-height: 125%;
  margin-bottom: 4px;
  @include point-md {
    font-size: 16px;
    margin-bottom: 8px;
  }
}
</style>
